import authAxios from "../common/authAxios";

class DictionaryService {
    getIssuingAuthority() {
        return authAxios.get(`/documents/document-issuing-authorities`);
    }
  
    getDocumentTypes() {
        return authAxios.get(`/documents/identity-document-types`);
    }
}

export default DictionaryService;